import React, { useEffect, useState } from 'react';
import { LuMessageSquareText, LuWrench } from 'react-icons/lu';
import api from '../../services/api';
import { VerFotos } from '../empresa/FotosPedido';

// Lo que mandó el cliente antes de la visita (29-oct-2026): el detalle y las fotos del pedido de la empresa,
// y de cada equipo del presupuesto qué hay que hacer y las fotos que mandó el cliente. Antes el técnico no
// veía nada de esto: llegaba sin saber qué le pasaba al equipo.
// 31-oct-2026: con la visita hecha acá también está lo que cargó el técnico al mismo equipo. Si el trabajo sabe
// de quién es cada foto (desde el 31-oct), va en dos bloques: lo que mandó el cliente y lo que hizo el técnico.
// Los trabajos anteriores no tienen ese dato y quedan en un solo bloque.
const rotulos = (fotos) => fotos.map(f => f.rotulo).filter(Boolean);
const nombreEquipo = (e) => [e.serie && `N/S ${e.serie}`, e.equipo, e.ubicacion].filter(Boolean).join(' · ');

function Equipo({ e, fotos, trabajo, siempre = false }) {
    if (!siempre && !trabajo && !fotos.length) return null;
    return (
        <div className="space-y-1.5 pt-2 border-t border-black/[0.06] dark:border-white/[0.06] first:border-t-0 first:pt-0">
            {nombreEquipo(e) && <p className="text-caption font-black text-secondary">{nombreEquipo(e)}</p>}
            {trabajo && <p className="text-body text-ink whitespace-pre-line">{trabajo}</p>}
            {fotos.length > 0 && <VerFotos fotos={fotos.map(f => f.archivo)} />}
            {rotulos(fotos).length > 0 && <p className="text-caption text-muted">{rotulos(fotos).join(' · ')}</p>}
        </div>
    );
}

function Bloque({ titulo, Icono = LuMessageSquareText, className = '', children }) {
    return (
        <div className={`rounded-2xl bg-panel p-3.5 space-y-3 ${className}`}>
            <p className="flex items-center gap-1.5 text-label font-black uppercase tracking-widest text-muted"><Icono size={14} /> {titulo}</p>
            {children}
        </div>
    );
}

export default function AntesDeIr({ ordenId, hecha = false, className = '' }) {
    const [d, setD] = useState(null);
    useEffect(() => {
        let vivo = true;
        api.get(`/ordenes/${ordenId}/antes-de-ir`).then(r => vivo && setD(r.data)).catch(() => {});
        return () => { vivo = false; };
    }, [ordenId]);
    if (!d) return null;
    const equipos = (d.equipos || []).filter(e => e.trabajo || e.fotos?.length || e.serie);
    const hay = d.detalle || d.fotos?.length || equipos.some(e => e.trabajo || e.fotos?.length);
    if (!hay) return null;

    // Dos bloques: visita hecha y el trabajo sabe de quién es cada foto
    if (hecha && d.conOrigen) {
        const de = (e, origen) => (e.fotos || []).filter(f => f.origen === origen);
        const delCliente = equipos.filter(e => de(e, 'cliente').length);
        const delTecnico = equipos.filter(e => e.trabajo || de(e, 'tecnico').length);
        const hayCliente = d.detalle || d.fotos?.length || delCliente.length;
        return (
            <div className={`space-y-3 ${className}`}>
                {hayCliente ? (
                    <Bloque titulo="Lo que mandó el cliente">
                        {d.detalle && <p className="text-body text-ink whitespace-pre-line">{d.detalle}</p>}
                        {d.fotos?.length > 0 && <VerFotos fotos={d.fotos.map(f => f.archivo)} />}
                        {delCliente.map((e, i) => <Equipo key={i} e={e} fotos={de(e, 'cliente')} />)}
                    </Bloque>
                ) : null}
                {delTecnico.length > 0 && (
                    <Bloque titulo="Lo que hizo el técnico" Icono={LuWrench}>
                        {delTecnico.map((e, i) => <Equipo key={i} e={e} fotos={de(e, 'tecnico')} trabajo={e.trabajo} />)}
                    </Bloque>
                )}
            </div>
        );
    }

    return (
        <Bloque titulo={hecha ? 'Fotos y detalle · cliente y técnico' : 'Lo que mandó el cliente'} className={className}>
            {d.detalle && <p className="text-body text-ink whitespace-pre-line">{d.detalle}</p>}
            {d.fotos?.length > 0 && <VerFotos fotos={d.fotos.map(f => f.archivo)} />}
            {equipos.map((e, i) => <Equipo key={i} e={e} fotos={e.fotos || []} trabajo={e.trabajo} siempre />)}
        </Bloque>
    );
}
